import { render, staticRenderFns } from "./GQrcode.vue?vue&type=template&id=684296a8&scoped=true&"
import script from "./GQrcode.vue?vue&type=script&lang=js&"
export * from "./GQrcode.vue?vue&type=script&lang=js&"
import style0 from "./GQrcode.vue?vue&type=style&index=0&id=684296a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684296a8",
  null
  
)

export default component.exports